<template>
  <div class="bg-dark-blue text-white flex flex-row">
    <header class="md:w-36 relative">
      <nav 
        class="fixed md:w-32 h-16 md:h-full md:border-r border-red px-6 md:p-12 md:top-0 left-0 right-0 z-90 bottom-0 bg-dark-blue"
        :class="{ '!bottom-0 !md:bottom-24': podcastStore.currentEpisode }"
      >
        <ul class="h-full w-full flex flex-row md:flex-col justify-between md:justify-start md:gap-12 items-center">
          <li>
            <router-link to="/" class="hover:text-red" exact-active-class="text-red">
              <svg class="size-6 md:size-full" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 12.9091H11.5852C11.8479 12.9007 12.103 12.9982 12.2932 13.1795L14.4523 15.3386C14.64 15.5264 14.8947 15.6318 15.1602 15.6318H21C21.5523 15.6318 22 15.1841 22 14.6318V5.99545C22 5.44317 21.5523 4.99545 21 4.99545H15.4398C15.1595 4.99524 14.8921 4.87781 14.7023 4.67159L12.5432 2.31932C12.3536 2.11594 12.0882 2.00031 11.8102 2H3C2.44772 2 2 2.44772 2 3V22" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </router-link>
          </li>
          <li>
            <router-link to="/podcasts" class="hover:text-red" active-class="text-red">
              <svg class="size-6 md:size-full" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.42859 9.80486V4.80961C3.42859 3.25791 4.57986 2 6.00002 2H18C19.4202 2 20.5714 3.25791 20.5714 4.80961V9.80486" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.7706 10.2927C6.70861 10.2929 6.6468 10.2993 6.58607 10.312C3.97115 10.8566 2 13.2625 2 16.1463C2 19.0302 3.97115 21.4361 6.58607 21.9807C6.6468 21.9934 6.70861 21.9998 6.7706 22C7.29832 21.99 7.7195 21.5461 7.71423 21.0054V11.2873C7.7195 10.7466 7.29832 10.3027 6.7706 10.2927V10.2927Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.2294 10.2927C16.7017 10.3027 16.2805 10.7466 16.2858 11.2873V21.0054C16.2805 21.5461 16.7017 21.99 17.2294 22C17.2914 21.9998 17.3532 21.9934 17.4139 21.9807C20.0288 21.4361 22 19.0302 22 16.1463C22 13.2625 20.0288 10.8566 17.4139 10.312C17.3532 10.2993 17.2914 10.2929 17.2294 10.2927Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>

            </router-link>
          </li>
          <li>
            <router-link to="/nyheter" class="hover:text-red" active-class="text-red">
              <svg class="size-6 md:size-full" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M16 3H4C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H17V5V4C17 3.44772 16.5523 3 16 3ZM17 22H18H20C21.1046 22 22 21.1046 22 20V6C22 4.89543 21.1046 4 20 4H18C18 2.89543 17.1046 2 16 2H4C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H17ZM20 21H18V5H20C20.5523 5 21 5.44772 21 6V20C21 20.5523 20.5523 21 20 21ZM5.8889 6.55555C5.33662 6.55555 4.8889 7.00326 4.8889 7.55555C4.8889 8.10783 5.33662 8.55555 5.8889 8.55555H14.2222C14.7745 8.55555 15.2222 8.10783 15.2222 7.55555C15.2222 7.00326 14.7745 6.55555 14.2222 6.55555H5.8889ZM5.8889 11C5.33662 11 4.8889 11.4477 4.8889 12C4.8889 12.5523 5.33662 13 5.8889 13H14.2222C14.7745 13 15.2222 12.5523 15.2222 12C15.2222 11.4477 14.7745 11 14.2222 11H5.8889ZM4.8889 16.4445C4.8889 15.8922 5.33662 15.4445 5.8889 15.4445H14.2222C14.7745 15.4445 15.2222 15.8922 15.2222 16.4445C15.2222 16.9967 14.7745 17.4445 14.2222 17.4445H5.8889C5.33662 17.4445 4.8889 16.9967 4.8889 16.4445Z" fill="currentColor"/>
              </svg>

          </router-link></li>
          <li><router-link :to="{ name: 'CalendarList' }" class="hover:text-red" active-class="text-red">
            <svg class="size-6 md:size-full" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M7.04344 3C7.31958 3 7.54344 3.22386 7.54344 3.5V5.26661H16.4564V3.5C16.4564 3.22386 16.6803 3 16.9564 3C17.2326 3 17.4564 3.22386 17.4564 3.5V5.26661H18.4998C20.4328 5.26661 21.9998 6.83362 21.9998 8.76661V13.3073L22.0001 13.3222L21.9998 13.3372V17.5C21.9998 19.433 20.4328 21 18.4998 21H5.5C3.56701 21 2 19.433 2 17.5V13.3222V8.76661C2 6.83362 3.567 5.26661 5.5 5.26661H6.54344V3.5C6.54344 3.22386 6.7673 3 7.04344 3ZM16.4564 6.26661V9.54536C16.4564 9.8215 16.6803 10.0454 16.9564 10.0454C17.2326 10.0454 17.4564 9.8215 17.4564 9.54536V6.26661H18.4998C19.8806 6.26661 20.9998 7.3859 20.9998 8.76661V12.8222L3 12.8222V8.76661C3 7.3859 4.11929 6.26661 5.5 6.26661H6.54344V9.54536C6.54344 9.8215 6.7673 10.0454 7.04344 10.0454C7.31958 10.0454 7.54344 9.8215 7.54344 9.54536V6.26661H16.4564ZM3 13.8222V17.5C3 18.8808 4.11929 20 5.5 20H18.4998C19.8806 20 20.9998 18.8808 20.9998 17.5V13.8222L3 13.8222ZM9.84781 17.1C9.84781 16.8239 10.0717 16.6 10.3478 16.6H16.9573C17.2334 16.6 17.4573 16.8239 17.4573 17.1C17.4573 17.3762 17.2334 17.6 16.9573 17.6H10.3478C10.0717 17.6 9.84781 17.3762 9.84781 17.1ZM7.04344 16.6C6.7673 16.6 6.54344 16.8239 6.54344 17.1C6.54344 17.3762 6.7673 17.6 7.04344 17.6H8.6958C8.97195 17.6 9.1958 17.3762 9.1958 17.1C9.1958 16.8239 8.97195 16.6 8.6958 16.6H7.04344Z" fill="currentColor"/>
            </svg>
          </router-link></li>
        </ul>
      </nav>
    </header>

    <main
      class="flex-1 p-6 md:p-12 overflow-hidden"
      :class="{ 'pb-38 md:pb-36': podcastStore.currentEpisode }"
    >
      <div v-if="podcastStore.isLoading && podcastStore.podcasts.length === 0" class="app-loading">
        📡 Laddar poddplattformen...
      </div>
      <div v-else-if="podcastStore.error && podcastStore.podcasts.length === 0" class="app-error">
        ⚠️ Gick inte att öppna appen: {{ podcastStore.error }}
      </div>
      <router-view :key="$route.fullPath" v-else />
    </main>

    <footer v-if="podcastStore.currentEpisode" class="fixed bottom-16 md:bottom-0 left-0 right-0 bg-red text-dark-blue z-100 h-16 md:h-18 overflow-hidden">
      <PodcastPlayer />
    </footer>
  </div>
</template>

<script setup>
import { onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { usePodcastStore } from './stores/podcastStore'
import PodcastPlayer from './components/PodcastPlayer.vue'

const route = useRoute()
const podcastStore = usePodcastStore()

onMounted(async () => {
  // 1. Ladda huvudlistan
  await podcastStore.fetchPodcasts()
  await podcastStore.fetchNews()
  await podcastStore.fetchEpisodes()
  await podcastStore.fetchEvents()

  // 2. Återställ senaste spelade med strikt textkontroll
  const savedEpisodeId = podcastStore.lastPlayedEpisodeId
  const savedPodcastId = podcastStore.lastPlayedPodcastId

  // HÄR ÄR FIXEN: Vi kollar att variablerna existerar OCH att de inte råkar innehålla textsträngen "undefined"
  if (savedEpisodeId && savedPodcastId && savedEpisodeId !== 'undefined' && savedPodcastId !== 'undefined') {
    try {
      await podcastStore.fetchPodcastDetails(savedPodcastId)
      
      const podcastData = podcastStore.getEpisodeById(savedEpisodeId)
      const episodeData = podcastStore.getEpisodeById(savedEpisodeId)
      if (podcastData && episodeData) {
        podcastStore.restoreLastPlayed(episodeData, podcastData.podcast)
      }
    } catch (err) {
      console.error("Gick inte att återställa senaste avsnittet:", err)
    }
  } else {
    // Om sparad data var trasig eller tom, rensa bort strängarna för att säkra framtida laddningar
    localStorage.removeItem('last_played_episode_id')
    localStorage.removeItem('last_played_podcast_id')
  }
})

// Håll utskik efter djuplänkar (?station=X&t=Y)
watch(
  () => route.query,
  async (newQuery) => {
    if (!newQuery || !newQuery.station || !newQuery.t || newQuery.station === 'undefined') return

    const targetPodcastId = newQuery.station

    try {
      await podcastStore.fetchPodcastDetails(targetPodcastId)
      
      const podcastData = podcastStore.getPodcastDetailsById(targetPodcastId)
      if (podcastData && podcastData.episodes.length > 0) {
        const firstEpisode = podcastData.episodes[0]
        podcastStore.playEpisode(firstEpisode, podcastData)
      }
    } catch (err) {
      console.error("Autoplay via djuplänk misslyckades:", err)
    }
  },
  { once: true }
)
</script>
